import { render } from "./notifications.vue?vue&type=template&id=3d1cc1bd"
const script = {}

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__